import { lazyLoad } from 'app/utils/loadable';

export const FaqPage = lazyLoad(
  () => import('./faq-page'),
  (module) => module.FaqPage
);
